import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import useActiveProcess from '../hooks/useActiveProcess';
import useActivePermission from '../hooks/useActivePermission';

const ProtectedRoute = ({
  element,
  allowedRoles = [],
  requireProcess = false, 
  requirePermission = false,
  redirectPath = '/login',
}) => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const activeProcess = useActiveProcess();
  const activePermission = useActivePermission();

  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }

  const hasAllowedRole = allowedRoles.length === 0 || user.roles.some((r) => allowedRoles.includes(r));
  if (!hasAllowedRole) {
    return <Navigate to={redirectPath} replace />;
  }

  if (requireProcess && !activeProcess) {
    return <Navigate to="/procesos-evaluacion" replace />;
  }

  if (requirePermission && !activePermission) {
    return <Navigate to="/procesos-evaluacion" replace />;
  }

  return element;
};

export default ProtectedRoute;